import { HttpClient, provideHttpClient, withFetch } from '@angular/common/http';
import { enableProdMode, provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, Routes, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideErrorHandlingTranslations } from '@oca/web-shared';
import { Observable, of } from 'rxjs';
import { AppComponent } from './app/app.component';
import { AppEffects } from './app/app.effects';

import { appFeature } from './app/app.reducer';
import { getInitialState } from './app/initial-state';
import { environment } from './environments/environment';

const routes: Routes = [
  {
    path: 'web/:cityUrlName',
    children: [{ path: 'news', loadChildren: () => import('./app/news/news.routes') },
    ],
  },
];
const oca = getInitialState();

if (environment.production) {
  enableProdMode();
}

class WebTranslateHttpLoader extends TranslateHttpLoader {
  getTranslation(lang: string): Observable<any> {
    // eslint-disable-next-line no-unsafe-optional-chaining
    if (typeof oca !== 'undefined' && lang in oca?.translations) {
      return of(oca.translations[lang]);
    }
    return super.getTranslation(lang);
  }
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideTranslateService({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new WebTranslateHttpLoader(http, '/common/i18n/web/', '.json'),
        deps: [HttpClient],
      },
    }),
    provideStore({ [appFeature.name]: appFeature.reducer }, {
      initialState: oca?.initialState,
      runtimeChecks: {
        strictActionImmutability: true,
        strictActionSerializability: true,
        strictActionWithinNgZone: true,
        strictStateImmutability: true,
        strictStateSerializability: true,
      },
    }),
    provideStoreDevtools({
      name: 'Our City App',
      maxAge: 25,
      logOnly: environment.production,
    }),
    provideEffects(AppEffects),
    provideErrorHandlingTranslations({
      error: 'web.Error',
      knownErrorKey: 'web.translated-error',
      unknownError: 'web.error-occured-unknown-try-again',
      retry: 'web.Retry',
      close: 'web.Close',
    }),
    provideHttpClient(withFetch()),
    provideRouter(routes, withComponentInputBinding(), withRouterConfig({ paramsInheritanceStrategy: 'always' })),
  ],
})
  .catch(err => console.error(err));
